import React, { useState } from "react";

const Title = () => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const toggle = isChecked ? (
    <div className="dot bg-backgroundColor absolute right-1 top-0.5 h-toggleHeight w-toggleWidth rounded-full transition"></div>
  ) : (
    <div className="dot bg-backgroundColor absolute left-1 top-0.5 h-toggleHeight w-toggleWidth rounded-full transition"></div>
  );

  return (
    <div>
      <div className="text-bodyColor text-4xl text-center font-Outfit font-bold break-words">
        Liquidate
      </div>
      <div className="text-bodyColor text-lg text-center font-Outfit font-normal break-words my-2.5">
        Liquidate to earn extra reward!
      </div>
      <div className="my-8 text-center">
        <div className="inline-flex justify-center items-center">
          <div className="text-bodyColor text-lg font-Outfit font-normal break-words">
            Ignore Small Debt
          </div>
          <label className="flex cursor-pointer select-none items-center ml-6">
            <div className="relative">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
                className="sr-only"
              />
              <div className="block h-[25px] w-[51px] rounded-full bg-toggleBackgroundColor"></div>
              {toggle}
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};

export default Title;
